module.exports = __webpack_public_path__ + "img/dev_tool_request_headers.9f882f6d.png";